<template>
    <page>
        <module enable-flex ref="view">
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="会员昵称" name="nick_name" placeholder="模糊下单会员昵称"></c-form-item>
                    <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone" placeholder="模糊下单会员手机号"></c-form-item>
                    <c-form-item type="input" label="订单号" name="order_number" placeholder="模糊订单号"></c-form-item>
                    <c-form-item type="input" label="下单商品" name="product_name" placeholder="模糊匹配下商品名称、规格"></c-form-item>
                    <c-form-item type="datetime" label="评价时间" start-name="start_date" end-name="end_date"></c-form-item>
                    <c-form-item type="checkbox" label="状态" name="state" :options="stateType"></c-form-item>
                </c-form>
            </m-search>

            <m-operate v-if="auth('b_order_evaluate_state')">
<!--
                <c-button color="m" v-if="auth('b_evaluate_prohibited_words')" @click="prohibitedWordsEdit()">违禁词管理</c-button>
-->
                <c-button v-if="auth('b_order_evaluate_state')" @click="disableActivity(2)" color="m" >批量启用</c-button>
                <c-button v-if="auth('b_order_evaluate_state')" @click="disableActivity(1)" color="red">批量禁用</c-button>
<!--
                <c-button color="m" hollow @click="syncExport()">导出评价数据</c-button>
-->

<!--                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>-->
            </m-operate>

            <c-table ref="table" code="order_evaluate_list">
                <c-table-column
                        type="selector"
                ></c-table-column>

                <c-table-column
                        label="状态"
                        name="start_state"
                        width="60"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 2" style="color:green">{{stateText[data.state]}}</span>
                        <span v-if="data.state == 1" style="color:red">{{stateText[data.state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="会员头像/昵称" name="share_user_nick_name" width="120">
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;">
                            </c-image>
                            <span>{{ data.nick_name || '--' }}</span>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="会员手机号"
                        name="user_manage_mobilephone"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="订单号"
                        name="order_number"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="下单商品"
                        name="product_name"
                        width="350"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_name + ' - '+data.product_sku_spec"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name + ' - '+data.product_sku_spec"></product-info>
                    </template>
                </c-table-column>

                <c-table-column
                        label="评分"
                        name="score"
                        width="50"
                ></c-table-column>

                <c-table-column
                        label="评价内容"
                        name="evaluate_comment"
                        width="180"
                ></c-table-column>

                <c-table-column
                        label="评价时间"
                        name="create_date"
                        width="145"
                ></c-table-column>

                <c-table-column
                        label="查看数量"
                        name="view_count"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="点赞数量"
                        name="thumb_count"
                        width="80"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
						width="160"
                >
                    <template v-slot="{data}">
                        <c-table-button @click="navigateTo(`/order_evaluate_detail/${data.id}`)">查看</c-table-button>
                        <c-table-button power="b_order_evaluate_state" v-if="data.state == 2" @click="disableActivity(1,data)">禁用</c-table-button>
                        <c-table-button power="b_order_evaluate_state" v-if="data.state == 1" @click="disableActivity(2,data)">启用</c-table-button>
                        <c-table-button  @click="del(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>

            <c-dialog ref="prohibitedWordsDialog" title="订单评价违禁词管理" width="600" button-name="确认" @resolve="prohibitedWordsHandle">
                <m-operate>
                    <c-button color="m" @click="addNewProhibitedWords()">添加违禁词</c-button>
                </m-operate>
                <c-table ref="wordList" v-model="prohibitedWordsList" height="400" :paging="false">
                    <c-table-column
                            label="违禁词"
                            width="350"
                    >
                        <template v-slot="{data}">
                            <c-input v-model="data.words" width="100%" height="30"></c-input>
                        </template>
                    </c-table-column>

                    <c-table-column
                            type="button"
                            fixed="right"
                            label="操作"
                            width="60"
                    >
                        <template v-slot="row">
                            <c-table-button @click="row.remove()">删除</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
            </c-dialog>

        </module>
    </page>
</template>

<script>
    import productInfo from "@/components/public/product_info.vue";
    import {mapGetters, mapState} from "vuex";

    export default {
        name: 'm_order_evaluate',
        components: {productInfo},

        computed: {
            ...mapState(['systemConfig', 'userInfo']),
            ...mapGetters({
                auth: 'power'
            }),
            stateText() {
                var state = {};
                this.stateType.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        data() {
            return {
                workType:33,
                searchParams:{},
                prohibitedWordsList:[],
                stateType: [{
                    name: '禁用',
                    value: 1
                },{
                    name: '启用',
                    value: 2
                }
                ]
            }
        },

        mounted() {
            this.$refs.search.search();
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/orderEvaluate/list',
                    data
                });
                this.searchParams = data;
            },

            disableActivity(state,item) {
                this._auditProductIds = [];
                var tip = "";
                if (item){
                    tip = state == 2 ? '确定要启用此评价吗？' : '确定要禁用此评价吗';
                    this._auditProductIds = [];
                    this._auditProductIds.push(item.id);
                }else {
                    //批量操作
                    var list = this.$refs.table.getRow('selected');
                    if (!list.length) {
                        this.$message({
                            text: '请选择要操作的记录'
                        });
                        return;
                    }
                    var flag = true;
                    list.forEach(function(item, index, array) {
                        if((state == 1 && item.data.state == 1)||(state == 2 && item.data.state == 2)){
                            flag = false;
                        }
                    });

                    if(!flag){
                        this.$message({
                            text: state == 1?'请选择【启用】状态的记录进行禁用操作！':'请选择【禁用】状态的记录进行启用操作'
                        });
                        return false;
                    }
                    tip = state == 2 ? '确定要启用【'+list.length+'】条评价吗？' : '确定要禁用【'+list.length+'】条评价吗';
                    this._auditProductIds = Array.from(list,item=>{
                        return item.data.id;
                    })
                }

                this.$confirm({
                    text: tip,
                    resolve: () => {
                        this.request({
                            url: '/orderEvaluate/updateState',
                            data: {
                                ids: this._auditProductIds,
                                state: state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: state == 2 ? '启用成功' :'禁用成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

            del(val) {
                this.$confirm({
                    text: '确定要删除此评价吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/orderEvaluate/remove',
                            data: {type:1,id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            //编辑违禁词数据
            prohibitedWordsEdit(){
                this.request({
                    url: '/orderEvaluate/prohibitedWords/detail',
                    data: {},
                    loading: true,
                    success: data => {
                        this.prohibitedWordsList = Array.from(data, item => {
                            return {
                                words: item
                            }
                        });
                        this.$refs.prohibitedWordsDialog.open();
                    }
                });
            },
            //添加新的违禁词
            addNewProhibitedWords(){
                let obj = {
                    words:''
                };
                this.prohibitedWordsList.push(obj);
            },
            //提交违禁词数据
            prohibitedWordsHandle() {
                var words_list = Array.from(this.prohibitedWordsList, item => {
                    return item.words
                });
                this.request({
                    url: '/orderEvaluate/prohibitedWords/edit',
                    data: {
                        words_list:words_list
                    },
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '违禁词编辑成功',
                            icon: 'success'
                        });
                        this.$refs.prohibitedWordsDialog.close();
                    }
                });
            },

            /**同步导出数据*/
            syncExport(){
                var selectDatas = this.$refs.table.getRow('selected');
                var ids = [];
                if (selectDatas.length && selectDatas.length>0) {
                    ids = Array.from(selectDatas, item => item.data.id);
                }
                this.export(this.workType,this.searchParams,ids);
            },
        }
    }
</script>
